<template>
  <div>
    <vs-divider/>
    <div class="row  mb-3">
      <div class="col-8">
        <h4>Distribución</h4>
      </div>
      <div class="col-4 d-flex align-items-end justify-content-end">
        <vs-button
          color="primary"
          icon="add"
          v-on:click="addDistribution()"

        >
          Agregar distribución
        </vs-button>
      </div>
    </div>
    <div class="row d-flex justify-content-center" v-if="distributions.length">
      <div
        class="col-8 mt-3 border-bottom"
        v-for="(distribution, index) in distributions"
        :key="`distribution-${index}`"
      >
        <div class="row text-center">
          <div class="col-5" v-b-tooltip:auto="distribution.name">
            {{ distribution.name }}
          </div>
          <div class="col-5" v-b-tooltip:auto="distribution.mail">
            {{ distribution.mail }}
          </div>
          <div class="col-2">
            <vs-icon
              color="red"
              style="cursor: pointer"
              icon="highlight_off"
              size="small"
              bg="white"
              round
              v-b-tooltip="'Remover distribución'"
              @click="$emit('remove-distribution', index)"
            />
          </div>
        </div>
      </div>
    </div>
    <b-modal
      size="lg"
      ref="distribution"
      no-close-on-backdrop
      ok-title="Agregar"
      cancel-title="Cancelar"
      @ok="handleOk"
      @cancel="cancelNewDistribution"
      title="Agregar distribución"
    >
      <form
        id="new-distribution-form"
        autocomplete="off"
        @submit.prevent
        size="sm"
        data-vv-scope="new-distribution"
      >
        <div class="row">
          <!--<span
            class="new-distribution-add"
            v-on:click="confirmNewDistribution()"
          >
            <vs-icon
              icon="done"
              size="small"
              bg="white"
              round
            />
          </span>
          <span
            class="new-distribution-delete"
            v-on:click="cancelNewDistribution()"
          >
            <vs-icon
              icon="highlight_off"
              size="small"
              bg="white"
              round
            />
          </span>-->
          <div class="col-6">
            <label
              for="name"
              v-b-tooltip="'Como nos referimos a la persona' +
                     ' a la que se le envie al finalizar'"
            >
              Nombre
            </label>
            <vs-input
              class="w-100"
              type="text"
              placeholder="Ingrese nombre del destinatario"
              v-model="newDistribution.name"
              maxlength="250"
              id="name"
              name="name"
              :danger="errors.has('new-distribution.name')"
              :danger-text="errors.first('new-distribution.name')"
              v-validate="'required'"
            />
          </div>
          <div class="col-6">
            <label
              for="newDistributionMail"
              v-b-tooltip="'Correo al que sera distribuido el expediente una ves finalice'"
            >
              Correo
            </label>
            <vs-input
              class="w-100"
              type="email"
              placeholder="Ingrese correo del destinatario"
              v-model="newDistribution.mail"
              maxlength="250"
              id="newDistributionMail"
              name="email"
              :danger="errors.has('new-distribution.email')"
              :danger-text="errors.first('new-distribution.email')"
              v-validate="'required|email'"
            />
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>
<script>

export default {
  name: 'DistributionFlow',
  data() {
    return {
      newDistribution: {}
    };
  },
  methods: {
    addDistribution() {
      this.newDistribution = {
        name: '',
        mail: ''
      };
      this.$refs.distribution.show();
    },
    async confirmNewDistribution() {
      const isValid = await this.$validator.validateAll('new-distribution');
      if (!isValid) {
        return;
      }
      this.$emit('new-distribution', this.newDistribution);
      this.$vs.notify({
        title: 'Genial!',
        text: 'Se ha agregado a la distribución',
        color: 'success',
        time: 5000,
        position: 'top-center'
      });
      this.newDistribution = {};
      await this.$validator.reset();
    },
    cancelNewDistribution() {
      this.newDistribution = {};
      this.$refs.distribution.hide();
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.confirmNewDistribution();
    }
  },
  props: {
    distributions: {
      type: Array,
      required: true
    }
  }
};
</script>
<style scoped>

.new-distribution-delete {
  position: absolute;
  top: -10px;
  right: -4px;
  font-size: 10px;
  color: var(--red);
  cursor: pointer;
}

.new-distribution-add {
  position: absolute;
  top: -10px;
  right: 20px;
  font-size: 10px;
  color: var(--green);
  cursor: pointer;
}

.distribution-delete {
  position: absolute;
  top: -10px;
  right: -4px;
  font-size: 10px;
  color: #b11e0b;
  cursor: pointer;
}
</style>
